var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('grid-loader',{staticClass:"spinner",attrs:{"loading":true,"color":"light-blue"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }